// Summary of the published return/exchange FAQ, reviewed October 12, 2026.
// The published FAQ and purchase documents remain the detailed policy sources.
export const RETURN_POLICY_URL = "/faqs";
export const RETURN_POLICY_SUMMARY = 'Eligible domestic retail purchases may qualify for a return within 3 calendar days or 150 miles, whichever occurs first, or an exchange on days 4–30 through 1,000 miles, whichever occurs first. A $1,500 restocking fee applies to either option. Vehicles must be returned in the same condition; transportation and shipping charges are non-refundable. Dealer-to-dealer and wholesale transactions are excluded. Additional terms and exclusions apply. Review the published return and exchange FAQ and your purchase documents before buying.';

// Imported inventory still contains this obsolete marketing prefix. Replace
// only that exact claim; preserve condition, equipment, and history details.
export function normalizePublicReturnClaims<T extends object>(vehicle: T): T {
    const copy = { ...vehicle } as T & Record<string, unknown>;
    for (const field of ["description", "comments", "semanticText"] as const) {
        const value = copy[field];
        if (typeof value === "string") {
            Object.assign(copy, { [field]: value.replace(
                /All of our vehicles come with a Money[ -]Back Guarantee[!.]?\s*/gi,
                "Return and exchange options are available for eligible domestic retail purchases. A $1,500 restocking fee, time and mileage limits, and other terms apply. See https://thiscar.com/faqs. "
            ) });
        }
    }
    return copy;
}
